import Reveal from "./Reveal";
import SectionHeader from "./SectionHeader";
import { useLanguage } from "../context/LanguageContext";
import { waLink } from "../data/siteConfig";
import { WhatsAppIcon } from "./WhatsAppIcon";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const Faq = () => {
  const { t } = useLanguage();

  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <SectionHeader
            eyebrow={t.faq.eyebrow}
            heading={t.faq.heading}
            sub={t.faq.sub}
          />
          <Reveal delay={0.15} className="mt-10">
            <a
              href={waLink(t.hero.waMessage)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-whatsapp-cta"
              className="group inline-flex items-center gap-2.5 rounded-full bg-bronze px-7 py-3.5 text-sm font-semibold text-white shadow-[0_10px_30px_rgba(184,151,104,0.35)] transition-colors duration-300 hover:bg-bronze-dark"
            >
              <WhatsAppIcon className="h-4 w-4 transition-transform duration-300 group-hover:-rotate-12" />
              {t.faq.cta}
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="lg:col-span-7">
          <Accordion type="single" collapsible className="flex flex-col gap-4">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="rounded-2xl border border-line bg-white px-6 shadow-[0_8px_30px_rgba(28,27,26,0.04)] md:px-8"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="py-6 text-start font-head text-lg text-ink hover:no-underline md:text-xl"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm md:text-base leading-relaxed text-taupe">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default Faq;
